<template>
	<div class="windowTips" v-show="showWindow">
		<div class="window">
			<div class="topTitle">提示</div>
			<!-- <div class="closeBtn" @click="windowSwitch">×</div> -->
			<div class="msg">
				<span>
					{{showMsg}}
				</span>
			</div>
			<div class="btnBox">
				<button class="purpleBtn" @click="toRecharge">{{strButtonOKText}}</button>
				<button v-show="showType!=1&&showType!=3" class="purpleBtn cancleBtn" @click="windowSwitch(false)">{{strButtonCancelText}}</button>
			</div>
		</div>
	</div>
</template>
<style scoped>
	.windowTips{
		width:100%;
		height:100%;
		background: rgba(0,0,0,0.5);
		position: fixed;
		top:0;
		left:0;
		z-index:99999;
	}
	.window{
		width:250px;
		padding:0 10px;
		height:170px;
		border-radius: 8px;
		background: #fff;
		position: absolute;
		top:0;
		left:0;
		right:0;
		bottom:0;
		margin:auto;
	}
	.closeBtn{
		position: absolute;
		top:-8px;
		right:5px;
		font-size:32px;
		color:#8B52E3;
		cursor: pointer;
	}
	.window .topTitle{
		line-height: 34px;
		color:#333;
		font-size:14px;
	}
	.window .msg{
		padding:0px 0;
		text-align: center;
		font-size:16px;
		color: #333;
		display: flex;
		flex-direction: column;
		justify-content:center;
		height: 90px;
		
	}
	.btnBox{
		text-align: center;
		position: absolute;
		bottom:12px;
		left:0;
		width:100%;
	}
	.btnBox button{
		width:100px;
		height:30px;
		line-height: 30px;
		text-align: center;
		border-radius: 15px;
	}
	.btnBox .cancleBtn{
		margin-left: 15px;
	}
</style>
<script>
	let hTimer = null;
	export default {
		name:'window',
		data(){
			return {
				strOKText: "确认",
				strCancelText: "取消",
				num:5,
				timer:false
			}
		},
		computed:{
			showWindow(){
				return this.$store.state.windowMsg.showBool
			},
			showType(){
				return this.$store.state.windowMsg.showType
			},
			showMsg(){
				return this.$store.state.windowMsg.showMsg
			},
			strButtonCancelText(){
				return this.strCancelText;
			},
			strButtonOKText(){
				return this.strOKText;
			}
		},
		methods:{
			windowSwitch(bool){
				if (!bool && hTimer) {
					clearInterval(hTimer);
					hTimer = null;
					if (this.showType == 1 || this.showType == 3) {
						this.strOKText='确认';
					}
					else{
						this.strOKText='登录';
						this.strCancelText='取消';
					}
				}
				this.$store.state.windowMsg.showBool=bool;
			},
			toRecharge(){
				if(this.showType==2){
					var str='reg_mac='+localStorage.getItem('mac')+'&nick_nm='+encodeURIComponent(this.$store.state.loginUserInfo.info.nick_nm)+'&token='+this.$store.state.loginUserInfo.token+'&user_id='+this.$store.state.loginUserInfo.info.user_id;
	                window.open('http://pay.live.sinashow.com/userinfo/site/webpc.html?'+str);
				}else if(this.showType==4){
					this.$store.dispatch('upDataLoginRegCloseBtnShowBool',true);
					this.$store.dispatch('upDataLoginRegShowBool',1);
				}
				this.windowSwitch(false);
			},
			set_text(){
				if (this.timer&&hTimer) {
					clearInterval(hTimer);
					hTimer = null;
					this.timer = false;
				}
				this.timer = true;
				if(this.timer){
					hTimer = setInterval(()=>{
						this.num--;
						if(this.num<=0){
							if (hTimer) {
								this.windowSwitch(false);
								if (this.showType == 1 || this.showType == 3) {
									this.strOKText = '确认';
								}
								else{
									this.strOKText='登录';
									this.strCancelText='取消';
								}
								clearInterval(hTimer);
								hTimer = null;
							}
						}else{
							if (this.showType == 1 || this.showType == 3) {
								this.strOKText = '确认(' + this.num + ')';
							}
							else{
								this.strCancelText = '取消(' + this.num + ')';
							}
						}
					}, 1000);
				}
			}
		},
		watch:{
			showMsg(newValue, oldValue){
				this.num = 6;
			},
			showWindow(newValue, oldValue){
				if (newValue) {
					this.num = 5;
					if (this.showType == 1 || this.showType == 3) {
						this.strOKText='确认(' + this.num + ')';
					}
					else{
						this.strCancelText='取消(' + this.num + ')';
					}
					this.set_text();
				}
			}
		}
	}
</script>